export default __webpack_public_path__ + "static/koa+ts-a2e603ec50abbd6fbadd220617e91190.jpg";